// extracted by mini-css-extract-plugin
export var container = "modal-module--container--1301a";
export var content = "modal-module--content--b0991";
export var overlay = "modal-module--overlay--d89e4";
export var path = "modal-module--path--1d55b";